module.exports = __webpack_public_path__ + "img/wb.daab1460.png";